<template>

  <ubi-page-container wide-main-content>
<!--    infos personnelles -->
    <ubi-panel>
      <!--<el-aside width="30%">-->
      <h3>{{ $t("profile.myPersonalInformation") }} - {{getUser.username}}</h3>
      <!--</el-aside>-->
      <el-main v-if="user">
        <el-form :model="user" id="userForm" ref="userForm" :rules="userRules">
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.lastname')">
                <el-input v-model="user.lastname"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.firstname')">
                <el-input v-model="user.firstname"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.email')" prop="email">
                <el-input v-model="user.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.phone')" prop="phone">
                <el-input v-model="user.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-main>
    </ubi-panel>
<!--    info agence -->
    <ubi-panel>
      <h3>{{ $t('profile.agencyInformation') }}</h3>
      <el-main v-if="sitimmoUser">
        <el-form :disabled="isSubUser" :model="sitimmoUser" id="sitimmoUserForm" ref="sitimmoUserForm" :rules="sitimmoUserRules">
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.corporateName')" prop="raisonSociale">
                <el-input v-model="sitimmoUser.raisonSociale"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.companyName')" prop="nom">
                <el-input v-model="sitimmoUser.nom"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.address')">
                <el-input v-model="sitimmoUser.adresse"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.postalCode')" prop="codePostal">
                <el-autocomplete
                    v-model="sitimmoUser.codePostal"
                    :fetch-suggestions="searchPostal"
                    @select="selectPostal">
                </el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.city')" >
                <el-input v-model="sitimmoUser.ville"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.country')"  prop="pays">
                <el-select
                    v-model="sitimmoUser.pays"
                    filterable
                    clearable
                >
                  <el-option
                      :key="pays.libelle"
                      :label="pays.translated_name"
                      :value="pays.libelle"
                      v-for="pays in getCountries"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.phone')" prop="telephone">
                <el-input v-model="sitimmoUser.telephone" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.fax')" prop="fax">
                <el-input v-model="sitimmoUser.fax" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.email')" prop="email">
                <el-input v-model="sitimmoUser.email" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.website')" prop="siteWeb">
                <UbiInputUrl v-model="sitimmoUser.siteWeb" ></UbiInputUrl>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="null">
              <el-form-item :label="$t('profile.price')" prop="lienTarifs">
                <UbiInputUrl :placeholder="$t('profile.placeholderPrice')" v-model="sitimmoUser.lienTarifs" ></UbiInputUrl>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item :label="$t('profile.logo')" >
              <el-upload
                  accept="image/jpeg, image/jpg, image/png, image/webp, image/gif, image/heic, image/avif"
                  :auto-upload="false"
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :on-change="handleFileSelect">
                <div slot="tip" class="el-upload__tip">{{$t("profile.uploadTip")}}</div>
                <el-tooltip :disabled="disabled" content="Cliquez pour Changer de logo" placement="top" effect="light">
                  <img v-if="sitimmoUser.logo" alt="" :src="'data:image/jpeg;base64,' + sitimmoUser.logo" class="el-upload-list__item-thumbnail avatar-uploader-icon">
                  <em v-else class="el-icon-plus avatar-uploader-icon"></em>
                </el-tooltip>
              </el-upload>
          </el-form-item>
        </el-form>
      </el-main>
    </ubi-panel>
<!--    configurations-->
    <ubi-panel>
      <h3>{{ $t("profile.Configurations") }}</h3>
      <el-main v-if="user">
        <el-form :model="user" id="userForm" ref="userForm" :rules="userRules">
          <el-row>
            <el-col :span="null">
              <span style="line-height: 1.5; font-weight: bold;">{{ $t("profile.saveFiltersTitle") }}</span>
            </el-col>
            <el-col :span="null">
              <el-checkbox v-model="user.saveFilters">{{ $t("profile.saveFilters") }}</el-checkbox>
            </el-col>
          </el-row>
          <br />
<!--          <el-row>-->
<!--            <el-col :span="null">-->
<!--              <span style="line-height: 1.5; font-weight: bold;">{{ $t("profile.activateAdsToTopFunctionalityTitle") }}</span>-->
<!--            </el-col>-->
<!--            <el-col :span="null">-->
<!--              <el-checkbox v-model="modeRemonterAnnoncesTeteListe" true-label="MANUEL" false-label="AUTOMATIQUE" @change="eventAnalyticsAdsToTop">-->
<!--                {{ $t("profile.activateAdsToTopFunctionality") }}-->
<!--              </el-checkbox>-->
<!--            </el-col>-->
<!--          </el-row>-->
          <br />
          <el-row v-if="sitimmoUser.metier === 'AGENCE'">
            <el-col :span="null">
              <span style="line-height: 1.5; font-weight: bold;">{{ $t("profile.soldProductMaskColorTitle") }}</span>
            </el-col>
            <el-col :span="null">
              <el-select v-model="sitimmoUser.bandeauBvCouleur" style="width: 200px !important;">
                <template slot="prefix">
                  <el-tag :style="'width: 45px; background-color:#' + sitimmoUser.bandeauBvCouleur">&nbsp;</el-tag>
                </template>
                <el-option
                    :key="color.code"
                    :label="'         #' + color.code"
                    :value="color.value"
                    v-for="color in maskColors">
                  <el-tag :style="'width: 45px; background-color:#' + color.code">&nbsp;</el-tag> #{{ color.code }}
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form>
        <ButtonScrollToTop @goToTop="goToTop" @scroll="handleScroll" v-if="buttonIsVisible" />
      </el-main>
    </ubi-panel>

    <template v-if="browserContext.up('md')">
      <div class="text-right">
        <el-button v-loading="loading" type="success" @click="submit()">
          <span>{{ $t("profile.save") }}</span>
        </el-button>
        <el-button @click="$router.go(-1)">{{ $t("profile.cancel") }}</el-button>
      </div>
    </template>
    <!--    etablishment sheet-->
    <EtablishmentSheet />
  </ubi-page-container>
</template>

<script>
import { tryRetrieveUser, updateSitimmoUser } from '@/services/auth'
import { updateUser } from '@/services/users'
import { Upload } from 'element-ui'
import { mapGetters, mapMutations } from 'vuex'
import { getCodePostalVille } from '@/services/toolbox'
import UbiInputUrl from '../components/forms/InputUrl'
import EtablishmentSheet from '@/pages/etablishment/EtablishmentSheet.vue'
import UbiPanel from '@/components/Panel.vue'
import ButtonScrollToTop from '@/components/ui/ButtonScrollToTop.vue'
import { buttonScrollToTopMixin } from '@/mixins/buttonScrollToTopMixin'
import fileTypeValidationMixin from '@/mixins/fileTypeValidationMixin'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPageContainer from '@/components/PageContainer.vue'

export default {
  name: 'Profile',
  inject: ['browserContext'],
  mixins: [buttonScrollToTopMixin, fileTypeValidationMixin],
  components: { UbiPageContainer, ButtonScrollToTop, UbiPanel, EtablishmentSheet, ElUpload: Upload, UbiInputUrl },
  data () {
    return {
      loading: false,
      disabled: false,
      userRules: {
        phone: [{ type: 'string', message: this.$t('validator.wrongFormat'), trigger: 'blur' }],
        email: [{ type: 'email', message: this.$t('validator.wrongFormat'), trigger: 'blur' }]
      },
      sitimmoUserRules: {
        codePostal: [{ type: 'string', message: this.$t('validator.wrongFormat'), trigger: 'blur' }],
        telephone: [{ type: 'string', message: this.$t('validator.wrongFormat'), trigger: 'blur' }],
        fax: [{ type: 'string', message: this.$t('validator.wrongFormat'), trigger: 'blur' }],
        email: [{ type: 'email', message: this.$t('validator.wrongFormat'), trigger: 'blur' }],
        lienTarifs: [{ type: 'url', message: this.$t('validator.httpOrHttps'), trigger: 'blur' }],
        siteWeb: [{ type: 'url', message: this.$t('validator.httpOrHttps'), trigger: 'blur' }],
        nom: [{ required: true, message: this.$t('validator.wrongFormat'), trigger: 'blur' }],
        raisonSociale: [{ required: true, message: this.$t('validator.corporateNameRequired'), trigger: 'blur' }]
      },
      maskColors: [
        { code: '9e0e40', value: '9e0e40' },
        { code: 'ff0000', value: 'ff0000' },
        { code: 'ff5e00', value: 'ff5e00' },
        { code: 'ffa500', value: 'ffa500' },
        { code: 'f3d440', value: 'f3d440' },
        { code: '87e990', value: '87e990' },
        { code: '008000', value: '008000' },
        { code: '0000ff', value: '0000ff' },
        { code: '50a9ac', value: '50a9ac' },
        { code: 'ee82ee', value: 'ee82ee' },
        { code: '46004e', value: '46004e' }
      ],
      maskColorDefault: 'ff0000',
      allowedImageTypes: [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/webp',
        'image/avif',
        'image/gif',
        'image/heic'
      ]
    }
  },
  beforeMount () {
    if (!this.sitimmoUser.bandeauBvCouleur) {
      this.sitimmoUser.bandeauBvCouleur = this.maskColorDefault
    }
  },
  computed: {
    ...mapGetters(['isSubUser', 'getCountries', 'getSitimmoUser', 'getUser']),
    sitimmoUser: {
      get () {
        return this.getSitimmoUser
      },
      set (value) {
        return this.setSitimmoUser(value)
      }
    },
    user: {
      get () {
        return this.getUser
      },
      set (value) {
        return this.setUser(value)
      }
    },
    modeRemonterAnnoncesTeteListe: {
      get () {
        return getFromSnake(
          this.sitimmoUser,
          'mode_remonter_annonces_tete_liste'
        )
      },
      set (value) {
        // on écrit TOUJOURS en camelCase côté front
        this.$set(
          this.sitimmoUser,
          'modeRemonterAnnoncesTeteListe',
          value
        )
      }
    }
  },
  methods: {
    ...mapMutations([
      'setSitimmoUser',
      'setUser'
    ]),
    onError (error) {
      this.error = error
    },
    eventAnalyticsAdsToTop () {
      if (this.$ga) {
        this.$ga.event('mon_compte', 'clic', 'activer_gestion_manuelle', this.sitimmoUser.id)
      }
    },
    cancelChange () {
      if (this.$ga) {
        this.$ga.event('mon_compte', 'clic', 'annuler', this.sitimmoUser.id)
      }
      this.$router.go(-1)
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    handleFileSelect (file, fileList = []) {
      // Validation du type de fichier
      if (!this.validateFileType(file, fileList, this.allowedImageTypes, {
        i18nKey: 'error.formatImage',
        formatsList: 'JPG, PNG, WebP, GIF, HEIC, AVIF'
      })) {
        return false
      }

      const rasterImageTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/webp',
        'image/gif',
        'image/avif'
      ]
      // if file size is less than 2Mo and format is a supported raster image (HEIC non converti ici)
      if (file.size <= 2000000 && rasterImageTypes.includes(file.raw.type)) {
        const self = this
        const previewReader = new FileReader()
        previewReader.onload = function (readerEvt) {
          self.sitimmoUser.logo = readerEvt.target.result.replace(/^data:image\/[^;]+;base64,/, '')
          self.$forceUpdate()
        }

        previewReader.readAsDataURL(file.raw)

        this.dialogVisible = false
      } else {
        this.$message.error('Votre logo n\'a pas pu être uploadé. Il dépasse le poids requis (2 Mo) ou n\'est pas dans un des formats requis: JPEG, PNG, WebP, GIF ou AVIF. Merci de rééssayer.')
      }
    },
    async searchPostal (queryString, cb) {
      const results = await getCodePostalVille(queryString, this.sitimmoUser.pays)
      if (results.type === 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      const tab = Object.values(results.result)
      cb(tab)
    },
    selectPostal (item) {
      this.sitimmoUser.ville = item.ville
      this.sitimmoUser.codePostal = getFromSnake(item, 'code_postal')
    },
    async submit () {
      this.loading = true
      this.error = null
      if (this.$ga) {
        this.$ga.event('mon_compte', 'clic', 'enregistrer', this.sitimmoUser.id)
      }
      await this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          const response = await updateUser({
            id: this.getUser.id,
            lastname: this.getUser.lastname,
            firstname: this.getUser.firstname,
            email: this.getUser.email,
            phone: this.getUser.phone,
            saveFilters: this.getUser.saveFilters
          })
          if (response.type === 'error') {
            this.loading = false
            return false
          }
          if (!this.isSubUser) {
            await this.$refs.sitimmoUserForm.validate(async (valid) => {
              if (valid) {
                if (this.sitimmoUser.bandeauBvCouleur == this.maskColorDefault) {
                  this.sitimmoUser.bandeauBvCouleur = null
                }
                await updateSitimmoUser({
                  id: this.sitimmoUser.id,
                  raisonSociale: this.sitimmoUser.raisonSociale,
                  nom: this.sitimmoUser.nom,
                  adresse: this.sitimmoUser.adresse,
                  codePostal: this.sitimmoUser.codePostal,
                  ville: this.sitimmoUser.ville,
                  pays: this.sitimmoUser.pays,
                  telephone: this.sitimmoUser.telephone,
                  fax: this.sitimmoUser.fax,
                  email: this.sitimmoUser.email,
                  siteWeb: this.sitimmoUser.siteWeb,
                  lienTarifs: this.sitimmoUser.lienTarifs,
                  logo: this.sitimmoUser.logo,
                  mode_remonter_annonces_tete_liste: this.sitimmoUser.mode_remonter_annonces_tete_liste,
                  bandeauBvCouleur: this.sitimmoUser.bandeauBvCouleur
                })
                await tryRetrieveUser(this.getUser.username)

                if (!this.sitimmoUser.bandeauBvCouleur) {
                  this.sitimmoUser.bandeauBvCouleur = this.maskColorDefault
                }

                this.loading = false
                this.$message({ type: 'success', message: this.$t('profile.messageSuccess') })
              } else {
                this.$message({ type: 'error', message: this.$t('validator.alertMandatoryFields') })
                this.loading = false
              }
            })
          } else {
            this.loading = false
            this.$message({ type: 'success', message: this.$t('profile.messageSuccess') })
          }
        } else {
          this.$message({ type: 'error', message: this.$t('validator.alertMandatoryFields') })
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: inline-block
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
